const ROUTES = {
    root: '/',
    Table: {
        root: '/table',
    },
    Order: {
        root: '/order/:orderId',
        search: '/order/search',
        number: '/order/number/:orderNumber',
        complete: '/order/:orderId/complete',
        receipt: '/order/number/:orderNumber/receipt',
    },
    CheckoutAssistant: {
        root: '/checkout-assistant',
    },
    Payment: {
        root: '/order/:orderId/payment/:paymentIntentId/:clientSecret',
        check: '/order/:orderId/check-payment/:paymentIntentId/:clientSecret',
    },
}

export { ROUTES }
